<script lang="ts">
    import { afterUpdate, onMount } from "svelte";
    import { storeIsPodcastDisplayed } from "../scripts/store";
    import { storePodcastPlayer } from "../scripts/classes/podcast";
    import { APP_VERSION } from '../scripts/constant';

    export 
    let audioPlay: boolean = false;
    let podcastCurrentTime: string = "0:00";
    let podcastDuration: string = "0:00";
    let podcastDurationNumber: number = 0;
    let rangeValue: number = 0;
    let volumeValue: number = 1;
    let isMute: boolean = false;
    let previousVolume: number = 1;
    let player;
    let podcastTitle = "";

    let src: string = "";
    onMount(async() => {
        storePodcastPlayer.subscribe((data) => {
        src = "../assets/files/podcasts/"+data.id+"_"+data.podcast_file_name;
        if (navigator.userAgent.toLowerCase().includes("mobi")) {
            podcastTitle = data.title.slice(0, 10) + "...";
        } else {
            podcastTitle = data.title;
        }
        let audio = <HTMLVideoElement>document.getElementById('monAudio');
        audioPlay = false;
        if (audio != null) {
            audio.load();
        }
    })
        podcastDuration = timeFormat(player.duration);
        podcastDurationNumber = player.duration;
        updatePodcastCurrentTime();
    })

    /**
     * playPause
     * 
     * Switch entre lecture et pause
     */
    function playPause() {
        if (player != null) {
            if (player.paused) {
                player.play();
                audioPlay = true;
            } else {
                player.pause();
                audioPlay = false;
            }
        }
    }

    /**
     * muteOnOff
     * 
     * Switch entre le on et le off
     */
    function muteOnOff() {
        if (isMute) {
            player.volume = previousVolume;
            volumeValue = previousVolume;
            isMute = false;
        } else {
            previousVolume = player.volume;
            player.volume = 0;
            volumeValue = 0;
            isMute = true;
        }
    }

    /**
     * updatePodcastCurrentTime
     * 
     * Mise à jour des infos sur l'avancement de la lecture du podcast
     */
    function updatePodcastCurrentTime() {
        rangeValue = player.currentTime;
        podcastCurrentTime = timeFormat(player.currentTime);
        if (player.currentTime >= (player.duration)) {
            audioPlay = false;
        }
    }

    /**
     * timeFormat
     * 
     * Transforme les secondes en hh:mm:ss
     * 
     * @param inSeconds
     */
    function timeFormat(inseconds): string {

        const hrs = Math.floor(inseconds/ 3600);
        const mins = Math.floor((inseconds % 3600) / 60);
        const secs = Math.floor(inseconds % 60);

        let ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;

        return ret;
    }

    afterUpdate(() => {
        if (Number.isNaN(player.duration)) {
            podcastDuration = "0:00";
        } else {
            podcastDuration = timeFormat(player.duration);
            podcastDurationNumber = player.duration;
        }
    })

    /**
     * initDuration
     * 
     * Utilisé quand les infos du podcast sont chargées
    */
    function initDuration() {
        podcastDurationNumber = player.duration;
    }

    /**
     * changePlay
     * 
     * Actualisation de la lecture lors du déplacement du curseur
     * 
     * @param event
     */
    function changePlay(event) {
        player.currentTime = event.target.valueAsNumber;
    }

    /**
     * changeVolume
     * 
     * Actualisation du volume lors du déplacement du curseur
     * 
     * @param event
     */
    function changeVolume(event) {
        player.volume = event.target.valueAsNumber;
        if (player.volume == 0) {
            isMute = true;
        } else {
            isMute = false;
        }
    }

    function close() {
        player.pause();
        audioPlay = false;
        storeIsPodcastDisplayed.set(false);
    }

</script>

<style lang="scss">

    .podcastplayer {
        position: fixed;
        bottom: -130px;
        width: 100%;
        height: 120px;
        background-image: url('../assets/images/bg_podcast.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        color: $color_white;
        z-index: 500;
        padding-top: 30px;
        transition: all 1s;
        &__open {
            bottom: 0px;
        }
        &__close {
            cursor: pointer;
            position: absolute;
            right: 10px;
            bottom: 100px;
        }
    }

    .audio {
        display: none;
    }

    .playButton {
        background-image: url("../assets/images/play.png");
        background-position: center;
        background-size: cover;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
        &__pause {
            background-image: url("../assets/images/pause.png");
        }
    }

    .duration {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 10px 0 0 0;
        color: $color_tertiary;
        font-weight: bold;
        font-size: 15px;
        text-shadow: -2px 0 $color_primary, 0 2px $color_primary, 2px 0 $color_primary, 0 -2px $color_primary;
    }

    .range {
        border: none;
        width: 50%;
    }
    .volume {
        border: none;
        width: 10%;
        &__img {
            cursor: pointer;
            background-image: url("../assets/images/volume.png");
            background-position: center;
            background-size: contain;
            width: 40px;
            height: 40px;
            &__mute {
                background-image: url("../assets/images/mute.png");
            }
        }
    }

    .ctrl {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }

    .version {
        text-align: end;
        margin: -10px 50px 0 0;
        font-size: 10px;
    }

    /* Style input range */
    /* reset */
    input[type="range"] {
        -webkit-appearance: none;
        appearance: none;
        background: transparent;
        cursor: pointer;
        padding: 0;
        margin: 0;
    }

    /* Style input range */
    /* Removes default focus */
    input[type="range"]:focus {
        outline: none;
    }

    /* Style input range */
    /* Chrome, Safari, Opera and Edge Chromium styles */
    /* slider track */
    input[type="range"]::-webkit-slider-runnable-track {
        background-color: $color_tertiary;
        height: 3.5px;
    }

    /* Style input range */
    /* Chrome, Safari, Opera and Edge Chromium styles */
    /* slider thumb */
    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none; /* Override default look */
        appearance: none;
        margin-top: -6.5px; /* Centers thumb on the track */
        background-color: $color_tertiary;
        border-radius: 50%;
        height: 15px;
        width: 15px;
        border: none;
    }

    /* Style input range */
    /* Firefox styles */
    /* slider track */
    input[type="range"]::-moz-range-track {
        background-color: $color_tertiary;
        height: 3.5px;
    }

    /* Style input range */
    /* Firefox styles */
    /* slider thumb */
    input[type="range"]::-moz-range-thumb {
        background-color: $color_tertiary;
        border: none; /*Removes extra border that FF applies*/
        border-radius: 50%;
        height: 15px;
        width: 15px;
    }

    @include large {
        .podcastplayer {
            height: 90px;
            &__close {
                bottom: 70px;
            }
        }
        .range {
            width: 80%;
        }

    }
</style>

<div class="podcastplayer" class:podcastplayer__open={$storeIsPodcastDisplayed}>
    <div class="duration">{podcastTitle} - {podcastCurrentTime} / {podcastDuration}<span class="podcastplayer__close" on:click={close} on:keydown={close}>X</span></div>
    <div class="ctrl">
        <div class="playButton" class:playButton__pause={audioPlay} on:click={playPause} on:keydown={playPause}></div>
        <input class="range" type="range" id="lenght" name="length"
        min="0" max="{podcastDurationNumber}" value={rangeValue} on:input={(e) => changePlay(e)}>
        <div class="volume__img" class:volume__img__mute={isMute} on:click={muteOnOff} on:keydown={muteOnOff}></div>
        <input class="volume" type="range" id="volume" name="volume"
                min="0" max="1" bind:value={volumeValue} step="0.1" on:input={(e) => changeVolume(e)}>
    </div>
    <audio id="monAudio" class="audio"
        controls preload="metadata"
        src={src} bind:this={player} on:timeupdate={() => updatePodcastCurrentTime()} on:loadedmetadata={() => initDuration()}>
    </audio>
    <div class="version">{APP_VERSION.version}</div>
</div>